import { ReactNode } from 'react';

import { Box, Typography } from '@mui/material';

import { LabeledText, LabeledTextSize } from 'components/text/LabeledText';

export type ProgressTextProps = {
    label: ReactNode;
    value: ReactNode;
    target: ReactNode;
    progress: number;
    success?: boolean;
    size?: LabeledTextSize;
};

export function ProgressText({ label, value, target, progress, success = false, size = 'md' }: ProgressTextProps) {
    let trackColor: string;

    if (progress >= 100 || success) trackColor = 'success.main';
    else if (progress >= 60) trackColor = 'warning.main';
    else trackColor = 'error.main';

    return (
        <LabeledText
            label={label}
            color={trackColor}
            size={size}
            value={
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.4, width: '100%' }}>
                    <Box sx={{ display: 'flex', alignItems: 'baseline', gap: 0.25 }}>
                        {value}

                        {target != null && (
                            <Box sx={{ display: 'inline-flex', alignItems: 'baseline', gap: '2px' }}>
                                <Typography sx={{ fontSize: 9, color: 'text.disabled', lineHeight: 1 }}>/</Typography>

                                {target}
                            </Box>
                        )}
                    </Box>

                    <Box sx={{ height: 3, bgcolor: 'grey.300', borderRadius: 99, overflow: 'hidden', width: '100%', mt: 0.5 }}>
                        <Box
                            sx={{
                                width: `${Math.min(progress, 100)}%`,
                                height: '100%',
                                bgcolor: trackColor,
                                borderRadius: 99,
                                transition: 'width 0.35s ease, background-color 0.25s ease',
                            }}
                        />
                    </Box>
                </Box>
            }
        />
    );
}
